import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Row, Col } from "react-bootstrap";
import * as yup from "yup";
import {
  getCarrierData,
  getFileTypeData,
  SaveMedicalCarrierData,
  UpdateMedicalCarrierData,
} from "../../../api/User/Hub/medicalcredentialsApi";
import Fontstyling from "../comman";
import theme from "../../../Utils/theme";
import CryptoJS from "crypto-js";
import DeleteModal from "../Modal/DeleteModal";
import Required from "../../Required";

const schema = yup.object().shape({
  Carrier: yup
    .string()
    .notOneOf(["Select Carrier"], "Please select carrier")
    .required("Please select carrier"),
  FileType: yup
    .string()
    .notOneOf(["Select File Type"], "Please select FileType")
    .required("Please select FileType"),
  AuthorizedUser: yup.string(),
  FileType: yup.string().required(),
  CarrierWebsite: yup
    .string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Enter correct url!"
    )
    .required("Please enter website"),
  UserName: yup.string().required("Please enter username"),
  Password: yup.string().required("Please enter a password"),
  // check minimum characters
  // .min(8, "Password must have at least 8 characters"),
  // LastImportDate: yup.date(),
  // DashboardDate: yup.date(),
});

const CarrierModal = ({
  show,
  onHide,
  witchAction,
  user,
  client,
  updateData,
  setResponseMessage,
  deleteMedicalCarrier,
  getData,
}) => {
  const [CarrierData, setCarrierData] = useState([]);
  const [fileTypesData, setFileTypesData] = useState([]);
  const buttonRef = useRef(null);
  useEffect(() => {
    getCarrier();
    getFileTypes();
  }, []);

  const getCarrier = () => {
    getCarrierData().then((res) => {
      setCarrierData(() =>
        res.data.sort((a, b) => {
          if (a.CarrierName.toLowerCase() < b.CarrierName.toLowerCase()) {
            return -1;
          }
          if (a.CarrierName.toLowerCase() > b.CarrierName.toLowerCase()) {
            return 1;
          }
          return 0;
        })
      );
    });
  };

  const getFileTypes = () => {
    getFileTypeData().then((res) =>
      setFileTypesData(() =>
        res.data.sort((a, b) => a.fileTypeName.localeCompare(b.fileTypeName))
      )
    );
  };

  const encryptData = (Password) => {
    const data = CryptoJS.AES.encrypt(
      JSON.stringify(Password),
      process.env.REACT_APP_AES_KEY
    ).toString();
    return data;
  };

  const handelSubmit = (e, bag) => {
    buttonRef.current.disabled = true;
    let initialValues = {
      Carrier: "",
      AuthorizedUser: user.UD_emp_name,
      CarrierWebsite: "",
      FileType: "",
      UserName: "",
      Password: "",
      LastImportDate: "",
      DashboardDate: "",
    };
    if (witchAction === "add") {
      let payload = {
        carrierID: +e.Carrier,
        clientId: client.clientID,
        regionID: client?.regionID,
        authorizedUserID: user?.UD_id,
        website: e.CarrierWebsite,
        fileTypeId: fileTypesData.find(
          (item) => item.fileTypeName === e.FileType
        ).fileTypeID,
        userName: e.UserName,
        password: encryptData(e.Password),
        lastImportDate: "2023-03-17T12:49:12.090Z",
        dashboardDate: "2023-03-17T12:49:12.090Z",
        createdBy: user?.UD_id,
      };

      SaveMedicalCarrierData(payload).then((res) => {
        if (res.data === "Requested region is rejected") {
          setResponseMessage("rejectedRegion");
        } else {
          setResponseMessage(res.data);
          getData();
        }
        bag.setValues(initialValues);
        onHide();
      });
    } else if (witchAction === "update") {
      let payload = {
        medCarID: updateData.MedCarId,
        website: e.CarrierWebsite,
        fileTypeId: fileTypesData.find(
          (item) => item.fileTypeName === e.FileType
        ).fileTypeID,
        userName: e.UserName,
        password: encryptData(e.Password),
      };
      UpdateMedicalCarrierData(payload).then((res) => {
        setResponseMessage(res.data);
        bag.setValues(initialValues);
        getData();
        onHide();
      });
    }
  };

  return (
    <Modal
      show={show}
      size={witchAction === "delete" ? "md" : "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={Fontstyling.modalHeading}
        >
          {witchAction === "add"
            ? "Add New "
            : witchAction === "update"
            ? "Update "
            : "Delete "}
          Credentials
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {witchAction === "delete" ? (
          <DeleteModal
            onClickYes={() => {
              deleteMedicalCarrier(updateData.MedCarId);
              onHide();
            }}
            onClickNo={() => onHide()}
          />
        ) : (
          <Formik
            validationSchema={witchAction !== "delete" && schema}
            onSubmit={handelSubmit}
            initialValues={{
              Carrier: updateData?.CarrierName
                ? updateData.CarrierName
                : "Select Carrier",
              AuthorizedUser: updateData?.UD_emp_name
                ? updateData?.UD_emp_name
                : user?.UD_emp_name,
              CarrierWebsite: updateData ? updateData.Website : "",
              FileType: updateData.FileTypeName
                ? updateData.FileTypeName
                : "Select File Type",
              UserName: updateData ? updateData.UserName : "",
              Password: updateData ? updateData.Password : "",
              LastImportDate: updateData ? updateData.LastImportDate : "",
              DashboardDate: updateData ? updateData.DashboardDate : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3 gap-3">
                  <Form.Group as={Col}>
                    <Form.Label style={Fontstyling.label}>
                      Carrier {witchAction !== "update" && <Required />}
                    </Form.Label>
                    <Form.Select
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      name="Carrier"
                      // value={values.Carrier}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={witchAction === "update"}
                      isInvalid={
                        values.Carrier === "Select Carrier" && touched.Carrier
                      }
                    >
                      <option value={"Select Carrier"}>Select Carrier</option>
                      {CarrierData.map((item, index) => {
                        return (
                          <option
                            value={item.CarrierID}
                            selected={item.CarrierName === values.Carrier}
                            key={index}
                          >
                            {item.CarrierName}
                          </option>
                        );
                      })}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.Carrier}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="validationFormik02">
                    <Form.Label style={Fontstyling.label}>
                      Authorized User
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      name="AuthorizedUser"
                      placeholder="Authorized User"
                      value={values.AuthorizedUser}
                      onChange={handleChange}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group as={Col} controlId="validationFormik03">
                    <Form.Label style={Fontstyling.label}>
                      Carrier Website <Required />
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Carrier Website"
                      maxLength={50}
                      name="CarrierWebsite"
                      value={values.CarrierWebsite}
                      onChange={handleChange}
                      isInvalid={
                        touched.CarrierWebsite && errors.CarrierWebsite
                      }
                      disabled={witchAction === "delete"}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.CarrierWebsite}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-3 gap-3">
                  <Form.Group as={Col} controlId="validationFormik04">
                    <Form.Label style={Fontstyling.label}>
                      File Type <Required />{" "}
                    </Form.Label>
                    <Form.Select
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      name="FileType"
                      value={values.FileType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={witchAction === "delete"}
                      isInvalid={
                        values.FileType === "Select File Type" &&
                        touched.FileType
                      }
                    >
                      <option value={"Select File Type"}>
                        Select File Type
                      </option>
                      {fileTypesData.map((item, index) => (
                        <option
                          value={item.fileTypeName}
                          key={index}
                          selected={
                            updateData.FileTypeName === item.fileTypeName
                          }
                        >
                          {item.fileTypeName}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please select file type
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="validationFormik05">
                    <Form.Label style={Fontstyling.label}>
                      User Name <Required />{" "}
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="User Name"
                      name="UserName"
                      value={values.UserName}
                      onChange={handleChange}
                      isInvalid={touched.UserName && errors.UserName}
                      disabled={witchAction === "delete"}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.UserName}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="3" controlId="validationFormik06">
                    <Form.Label style={Fontstyling.label}>
                      Password <Required />{" "}
                    </Form.Label>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="password"
                      placeholder="Password"
                      name="Password"
                      value={values.Password}
                      onChange={handleChange}
                      isInvalid={touched.Password && errors.Password}
                      disabled={witchAction === "delete"}
                      maxLength={20}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.Password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <div className="d-flex align-items-center justify-content-end gap-3">
                  <button
                    ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    save
                  </button>
                  <button
                    style={Fontstyling.cancelbutton}
                    type="reset"
                    onClick={() => {
                      // resetForm();
                      onHide();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CarrierModal;
